import isEmpty from '@/utils/is-empty';
import type { PageProps } from '@adobe/aem-react-editable-components';

const config = {
	emptyLabel: 'XFPage',
	isEmpty: isEmpty<PageProps>,
};

export default config;
